import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
export function Guarantee() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-172" data-mp="20m4obp53y8tf">
      <div className="mx-auto w-full max-w-3xl" data-id="element-173" data-mp="24myekp60vzph">
        <div className="rounded-3xl border border-green-200 bg-green-50/70 p-6 text-center sm:p-10" data-id="element-174" data-mp="24l3sh7j0m1jt">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-600" data-id="element-175" data-mp="29g1cf9hu1vbh">
            <ShieldCheckIcon className="h-9 w-9 text-white" aria-hidden="true" data-id="element-176" data-mp="2efdvrk9hwk9b" />
          </span>
          <h2 className="mt-5 font-display text-[24px] font-black leading-tight text-navy-950 sm:text-3xl" data-id="element-177" data-mp="2oaxqi3cbpcwh">
            🛡️ Garantía de Satisfacción de 7 Días
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-navy-800/85 sm:text-lg" data-id="element-178" data-mp="tx69ujvktsrj">
            Queremos que pruebes Ruta Hipotiroidismo™ sin asumir ningún riesgo.
            Si durante los primeros 7 días consideras que el contenido no cumple
            con lo prometido o no aporta mayor claridad a tu práctica clínica,
            simplemente escríbenos.
          </p>
          <p className="mt-4 font-display text-xl font-black text-green-800 sm:text-2xl" data-id="element-179" data-mp="3nsn4orz202mb">
            Te devolveremos el 100% de tu dinero.
          </p>
          <p className="mt-3 text-[14px] font-medium leading-relaxed text-navy-800/70 sm:text-base" data-id="element-180" data-mp="3dxbrwf77h5h7">
            Sin formularios complicados. Sin explicaciones. Sin letras pequeñas.
            Así de simple.
          </p>
        </div>

        <TransformCTA headline="El riesgo es cero: pruébala 7 días y decide con tus propios pacientes." data-id="element-181" data-mp="aglc58ltne2b" />
      </div>
    </section>;
}